<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells">
        <div
          class="weui-cell weui-cell_select weui-cell_select-after">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.ms_remark || "补卡理由"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.ms_remark"
              placeholder="请选择"
            >
              <option>忘记打卡</option>
              <option>指纹无法识别</option>
              <option>卡机故障</option>
              <option>软件异常</option>
              <option>无法定位</option>
              <option>网络异常</option>
              <option>其他</option>
            </select>
          </div>
        </div>
        <!-- <datetime-field slot="ms_signtime" :label="customLabel.ms_signtime || '补卡时间'" v-model="form.main.ms_signtime" /> -->
        <date-field label="补卡时间" v-model="form.main.clock_date"/>
        <clock-time-field :clockDate="form.main.clock_date"
          label="补卡时段"
          v-model="form.main.clock_time"
        />
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <textarea
              class="weui-textarea"
              :placeholder="customLabel.ms_address || '补卡地点'"
              rows="3"
              v-model="form.main.ms_address"
              maxlength="100"
            ></textarea>
            <div class="weui-textarea-counter">
              <span>{{
                form.main.ms_address ? form.main.ms_address.length : 0
              }}</span
              >/100
            </div>
          </div>
        </div>

        <file-field v-model="form.main.ms_attach"  />
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
// import CustomLayout from "@/components/layout/CustomLayout.vue";
import DateField from "@/components/field/DateField.vue";
import ClockTimeField from "@/components/field/ClockTimeField.vue";
import FileField from "@/components/field/FileField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    // CustomLayout,
    DateField,
    ClockTimeField,
    FileField
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/oa/mobilesigncard",
      codeField: "ms_code",
      statusField: "ms_statuscode",
      caller: "MobileSignCard",
      xtype: "oa-mobilesigncard-formpanel",
      form: {
        main: {
          ms_remark: "忘记打卡",
          ms_signtime: null,
          ms_address: null,
          clock_date: this.dateFormat(new Date(), "yyyy-MM-dd"),
          clock_time: null,
        },
      },
    };
  },
  mounted() {
    if (this.$route.query.date) {
      this.form.main.ms_signtime = this.$route.query.date;
      let arr = this.form.main.ms_signtime.split(' ')
      this.form.main.clock_date = arr[0]
    }
  },
  methods: {
    clearTime(){
      this.form.main.clock_time = null
    },
    save() {
      var me = this,
        main = me.form.main;
      if(!main.clock_date){
        me.$weui.topTips("请选择补卡时间", 2000);
      }else if (!main.clock_time) {
        me.$weui.topTips("请选择补卡时段", 2000);
      } else if (!main.ms_address) {
        me.$weui.topTips("请填写补卡地址", 2000);
      } else {
        me.form.main.ms_signtime = me.dateFormat(main.clock_date, "yyyy-MM-dd")  + ' '+ main.clock_time
        me.check();
      }
    },
    check() {
      var me = this;
      me.$loading({
        url: "/api/oa/mobilesigncard/check",
        params: {
          day: me.form.main.ms_signtime,
        },
      }).then(function (res) {
        if (res.success) {
          me.p_save();
        } else {
          me.$weui.topTips(res.message, 2000);
        }
      });
    },
  },
};
</script>